<template>
  <section class="discover-membership-types md:bg-neutral-50 md:py-10">
    <div class="max-w-1192">
      <div class="px-4 mb-6 md:text-center">
        <p class="o-body text-newBlue-400 mb-2" v-text="$t('LandingsPage.Men.MembershipTypes.DiscoverOur')" />
        <p class="o-heading-2 text-neutral-800" v-text="$t('LandingsPage.Men.MembershipTypes.Memberships')" />
        <div class="bg-newBlue-400 spacer w-10 rounded mt-2 md:mx-auto" />
      </div>
      <div
        ref="scrollContainer"
        class="flex overflow-x-scroll disable-scrollbars horizontal-scroll pr-6 md:pr-0"
        tabindex="0"
        role="region"
        aria-label="Membership types"
        @keydown.left="scrollLeft"
        @keydown.right="scrollRight"
      >
        <article
          v-for="(membershipType, i) in membershipTypes"
          :key="`${membershipType.title}-${i}`"
          class="flex-1 horizontal-scroll-start"
          :class="{
            'pl-9': i !== 0,
            'pl-4 md:pl-0': i === 0
          }"
        >
          <div class="rounded flex justify-center">
            <OImage
              v-bind="membershipType.image"
              img-class="rounded discover-membership-types-image"
              :alt="$t('Accessibilty.AltTags.PhotoOfMembershipTypeWithName', { name: membershipType.title })"
            />
          </div>
          <p class="pt-4 o-heading-5 text-center" v-text="membershipType.title" />
          <p class="o-body text-center mt-6" v-text="membershipType.description" />
        </article>
      </div>
    </div>
  </section>
</template>

<script>
import { getImagePaths } from '@/utils/general'
import OImage from '@/components/OImage'

export default {
  name: 'DiscoverMembershipTypes',
  components: { OImage },
  computed: {
    membershipTypes () {
      const path = 'LandingsPage.Men.MembershipTypes.MembershipTypes'
      const items = this.$t(path)

      if (!Array.isArray(items)) {
        return []
      }

      const membershipTypes = items.map((_, i) => ({
        image: getImagePaths({
          path: this.$t(`${path}[${i}].Url`),
          s3: true
        }),
        title: this.$t(`${path}[${i}].Title`, { ...this.variables }),
        description: this.$t(`${path}[${i}].Description`, { ...this.variables })
      }))

      return membershipTypes
    }
  },
  methods: {
    scrollLeft () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft -= 200 // Adjust scroll amount as needed
      }
    },
    scrollRight () {
      if (this.$refs.scrollContainer) {
        this.$refs.scrollContainer.scrollLeft += 200 // Adjust scroll amount as needed
      }
    }
  }
}
</script>

<style scoped lang="postcss">
.discover-membership-types {
  .oimage >>> img {
    max-width: 20rem;
  }

  .horizontal-scroll {
    @apply overflow-x-scroll;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;

    &-start {
      scroll-snap-align: start;
    }
  }

  .max-w-1192 {
    @apply mx-auto;
    max-width: 119.2rem;
  }

  .spacer {
    height: .2rem;
  }
}

/* Add visual indication of focus */
.horizontal-scroll:focus {
  outline: 2px solid #36C0B6; /* Use your primary color */
  outline-offset: -2px;
}

/* Add scrollbar styling for visual users */
.horizontal-scroll {
  scroll-behavior: smooth; /* For smooth scrolling */
}
</style>
